module.exports = __webpack_public_path__ + "img/ic_mail.8d2568bc.svg";